import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Select } from 'components/common/form';

const CertificatesAddCourse = ({ courses, templateId, updateTemplates }) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const submit = async (values) => {
    await api.post(`/admin/certificate-templates/${templateId}/courses`, {
      courseId: values.courseId
    });
    await updateTemplates();
    dispatch(
      actions.addNotice({
        text: messages.commonAddCourseSuccess,
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonIcon="plus"
      buttonText={messages.commonAddCourse}
      modalActionText={messages.commonAdd}
      modalTitle={messages.commonAddCourse}
      onSubmit={submit}
      pristineIsValid={false}
      stopPropagation={true}
    >
      {(formState) => (
        <FormGroup label={messages.commonCourse}>
          <Select
            field="courseId"
            id={`certificate-templates-add-course-${templateId}`}
            options={courses.map((course) => ({
              label: course.title,
              value: course.id
            }))}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CertificatesAddCourse;
